interface Props {
  removeMobilePagination?: boolean
  pageSize: number
  pageIndex: number
  rowCount: number
}

const ResumePagination = ({
  removeMobilePagination,
  pageSize,
  pageIndex,
  rowCount
}: Props) => {
  let to = (pageIndex + 1) * pageSize

  if (to > rowCount) {
    to = rowCount
  }

  return (
    <p
      className={`text-sm text-gray-700 ${
        removeMobilePagination ? "pb-3 md:pb-0" : ""
      }`}
    >
      Showing{" "}
      <span className="font-medium">
        {(pageIndex + 1) * pageSize - pageSize + 1}
      </span>{" "}
      to <span className="font-medium">{to}</span> of{" "}
      <span className="font-medium">{rowCount}</span> results
    </p>
  )
}

export default ResumePagination
